export const state = () => {
    return {
        filters: {},
        selectedFilters: {
            campaignName: '',
            adGroupName: '',
            siteIdIn: [],
            deviceIdIn: [],
            sourceIdIn: [],
            marketIdIn: [],
            boughtClicksGte: 0,
            soldClicksGte: 0,
            profitGte: null,
            opCtrInRange: [null, null],
            rpcInRange: [null, null],
            searchPhrase: "",
            dateRangesIn: [],            
        },
        limit: 25,
        direction: null,
        cursor: null,
        report: {},
        dailyReport: {},
        selectedColumns: [],
        fixedColumns: [],
        sortedColumns: [],
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/adgroupReport2/state.js